import { DOMOutputSpecArray, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../editor/types';
import { NodeName } from '../../schema/nodes';

export class OrderedListNode implements NodeSpec {
  public static readonly nodeName = NodeName.OrderedList;
  public static is(node: ProsemirrorNode) {
    return node.type.name === OrderedListNode.nodeName;
  }
  public content = 'list_item+';
  public group = 'block';
  public attrs = { order: { default: 1 } };
  public parseDOM = [
    {
      tag: 'ol',
      getAttrs: (dom: HTMLElement) => ({
        order: dom.hasAttribute('start') ? parseInt(dom.getAttribute('start')!, 10) : 1,
      }),
    },
  ];
  public toDOM = (node: ProsemirrorNode): DOMOutputSpecArray =>
    node.attrs.order === 1 ? ['ol', 0] : ['ol', { start: node.attrs.order }, 0];
}

export class BulletListNode implements NodeSpec {
  public static readonly nodeName = NodeName.BulletList;
  public static is(node: ProsemirrorNode) {
    return node.type.name === BulletListNode.nodeName;
  }
  public content = 'list_item+';
  public group = 'block';
  public parseDOM = [{ tag: 'ul' }];
  public toDOM = (): DOMOutputSpecArray => ['ul', 0];
}

export class ListItemNode implements NodeSpec {
  public static readonly nodeName = NodeName.ListItem;
  public static is(node: ProsemirrorNode) {
    return node.type.name === ListItemNode.nodeName;
  }
  public defining = true;
  public content = 'paragraph block*';
  public parseDOM = [{ tag: 'li' }];
  public toDOM = (): DOMOutputSpecArray => ['li', 0];
}

export type ListSchema = RtSchemaType<
  typeof OrderedListNode | typeof BulletListNode | typeof ListItemNode
>;
